import { render, staticRenderFns } from "./home-view.vue?vue&type=template&id=fce88458&scoped=true&"
import script from "./home-view.vue?vue&type=script&lang=js&"
export * from "./home-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fce88458",
  null
  
)

export default component.exports